import { FC } from 'react'
import { RouteObject } from 'react-router-dom'
import { ArpDetails } from '../features/details-page'
import { Segment } from '../features/segment'

const SampleDetailsPage: FC = () => (
  <Segment.ViewTracker attributes={{ path: '/sample'}}>
    <ArpDetails />
  </Segment.ViewTracker>
)

export const SampleDetailsRoute: RouteObject = {
  path: '/sample',
  element: <SampleDetailsPage />
}
